const common = {
  enabled: false
}

const nrcs = {
  shows: [],
  formatMap: [],
  capsLockTitle: true
}

const inews = {
  ...common,
  ...nrcs,
  notifier_path: '/inewsnotification/',
  ws_path: '/inewswebservice/services/',
  wsapi_server_real: 'c1pxinapi01.ad.ewsad.net',
  wsapi_server: 'c1pxinapi01.ad.ewsad.net',
  port: 8080,
  inews_server: '',
  username: '',
  password: '',
  services: ['inewssystem', 'inewsqueue', 'inewsstory'],
  approvedScripts: '',
  storyGroupMethod: 'Blank Line',
  archiveDelay: 30,
  videoMosId: ''
}

const enps = {
  ...common,
  ...nrcs,
  key: '',
  apiUrl: 'http://c1dwenpsb01.ad.ewsad.net/nomwebservices3api/api',
  userId: '',
  password: '',
  domainId: '',
  domainName: 'ad',
  database: '',
  basePath: '',
  homePath: '',
  archiveDelay: 30,
  videoMosId: ''
}

const softron = {
  ...common,
  ...nrcs,
  apiUrl: '',
  mediaRoot: '/Volumes/OTT CONTENT/_PLAYOUT'
}

const brightspot = {
  ...common,
  ...nrcs,
  callLetters: '',
  baseURL: 'https://qa.ewscripps.psdops.com/_scripps/api/v1',
  editURL: 'https://qa.ewscripps.psdops.com/cms/content/edit.jsp?id=',
  authKey: '',
  tags: [''],
  sectionId: '',
  contentSource: ''
}

const catdv = {
  ...common,
  user: '',
  password: '',
  hostname: '',
  baseURL: '',
  apiURL: '',
  archiveExtension: 'mov',
  archiveCatalogID: '',
  archiveCachePath: '',
  fieldGroup: '',
  archiveCatalogRoot: ''
}

export const systemTemplates = {
  inews,
  enps,
  softron,
  brightspot,
  catdv
}
